// extracted by mini-css-extract-plugin
export default {"loginContainer":"login_loginContainer__bdjRH","image":"login_image__bzkm8","loginBox":"login_loginBox__mM4US","carID":"login_carID__9zIPw","text":"login_text__lJewz"};